function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}
export {
  baseUnary as default
};
//# sourceMappingURL=_baseUnary.js.map
